// BNB
export const DEFAULT_INPUT_CURRENCY = 'MATIC'
// LUCHOW
export const DEFAULT_OUTPUT_CURRENCY = '0xc4bb7277a74678f053259cb1f96140347efbfd46'
